import FavoriteButton from '../FavoriteButton';
import { typeToLabel } from './GalleryResultPreview';
import PostTypeBadge from './PostTypeBadge';

export default function ListResultPreview({ item }) {
	let type = item?.contentType?.node?.graphqlSingleName;
	let typeLabel = typeToLabel(type);
	let id = item?.databaseId;

	if (
		item?.actorTypes?.nodes?.filter(o => o.name === 'Organisasjoner')
			.length > 0
	) {
		type = 'organization';
		typeLabel = 'Organisasjon';
	}

	return (
		<div class="flex flex-col gap-y-1 pt-4 pb-3 md:py-2.5 md:gap-y-0 lg:items-center border-gray border-b text-sm md:flex-row md:gap-x-5 sm:text-base">
			<div class="flex justify-between md:hidden">
				<PostTypeBadge type={type} label={typeLabel} />
				<FavoriteButton id={id} />
			</div>
			<div class="md:w-2/12 py-2 md:py-0 font-bold font-display lg:truncate">
				<a
					href={item?.link}
					class="no-underline hover:underline text-base"
				>
					{item?.title}
				</a>
			</div>
			<div class="md:w-4/12 flex gap-x-1.5 lg:truncate">
				{item?.industries?.nodes?.length >= 1 && (
					<>
						<span class="w-5 text-center flex-shrink-0 md:hidden">
							<i class="far fa-industry-alt"></i>
						</span>
						<p class="lg:truncate">
							{item.industries.nodes.map((term, i) =>
								i === 0 ? term.name : `, ${term.name}`
							)}
						</p>
					</>
				)}
			</div>
			<div class="md:w-2/12 flex gap-x-1.5">
				{item?.species?.nodes?.length >= 1 && (
					<>
						<span class="w-5 text-center flex-shrink-0 md:hidden">
							<i class="far fa-fish"></i>
						</span>
						<p class="lg:truncate">
							{item.species.nodes.map((term, i) =>
								i === 0 ? term.name : `, ${term.name}`
							)}
						</p>
					</>
				)}
			</div>
			<div class="md:w-1/12 flex gap-x-1.5">
				{item?.counties?.nodes?.length >= 1 && (
					<>
						<span class="w-5 text-center flex-shrink-0 md:hidden">
							<i class="far fa-map-marker-alt"></i>
						</span>
						<p class="lg:truncate">
							{item.counties.nodes.map((term, i) =>
								i === 0 ? term.name : `, ${term.name}`
							)}
						</p>
					</>
				)}
			</div>
			<div class="hidden md:w-3/12 md:flex md:items-start md:justify-end md:gap-x-1.5">
				<PostTypeBadge type={type} label={typeLabel} />
				<FavoriteButton id={id} />
			</div>
		</div>
	);
}
